import { TreePanel } from "@scmlatam/web-ui";

import type { useStepper } from "../hooks/useStepper";

const StepCategory = (props: ReturnType<typeof useStepper>) => {
  const {
    t,
    categories,
    loadingCategories,
    selectedIds,
    setSelectedIds,
    expandedIds,
    setExpandedIds,
  } = props;

  return (
    <>
      <TreePanel
        title={t("step1.tree_panel.title")}
        items={categories}
        selectedIds={selectedIds}
        onSelectionChange={(nextSelectedIds) => {
          setSelectedIds(nextSelectedIds);
        }}
        expandedIds={expandedIds}
        onExpandedChange={(nextExpandedIds) => {
          setExpandedIds(nextExpandedIds);
        }}
        loading={loadingCategories}
      />
    </>
  );
};

export { StepCategory };
